module.exports = __webpack_public_path__ + "img/injury_injury_icon.2eaf6f9d.svg";